export default function faqCategoryUI () {
	$('.faqs-category').each(function() {
		initFiltration($(this));
	});
}

const initFiltration = ($section) => {
	const $items = $section.find('.faqs-category__items');
	let prefilter = ''

	if ($section.hasClass('js-prefilter')) {
		prefilter = $section.find('.faqs-category__nav a').first().data('filter');
		$section.find('.faqs-category__nav a').first().addClass('active');
	}

	const $grid = $items.isotope({
		itemSelector: '.faqs-category__item',
		filter: prefilter
	});

	$section.find('.faqs-category__nav a').on('click', function(event) {
		event.preventDefault();

		const filter = $(this).data('filter');

		$(this).addClass('active').parent().siblings().find('a').removeClass('active');

		$grid.isotope({ filter });		
	});
}
